var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fragment',[(_vm.displayOption(_vm.value).fileName)?_c('video-player',{ref:"videoPlayer",staticClass:"video-player-box",attrs:{"options":_vm.playerOptions(),"playsinline":true}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }